<template>
    <span>{{ countDownTime }}</span>
</template>

<script>
let timer = null;
import moment from "moment";
export default {
    name: 'CountDown',
    data() {
       return {
        currentTime: moment().format('YYYY-MM-DDTHH:mm'),
        startTime: moment().format('YYYY-MM-DDTHH:mm'),
        countDownTime:'00:00:00',
        timer:''
      }
    },
    props:{
      endTime:String,
      contentId:String
    },
    mounted(){
      this.calculate();
      this.timer = setInterval(() => {
        this.calculate();
      }, 1000);
    },
    methods:{
      calculate(){
        const seconds = moment(this.endTime).diff(new Date, 'seconds');
        if (seconds <= 0) {
            this.$emit('removeCon',this.contentId,false);
            this.countDownTime = '秒杀已结束';
            setTimeout(()=>{
              clearInterval(this.timer);
            },999)
            return;
        }
        const second = seconds%60 >=10 ? seconds%60 : '0' + seconds%60;
        const minutes = (seconds-second) / 60;
        const minute = minutes%60 >=10 ? minutes%60 :'0' + minutes%60;
        const hours = (minutes-minute) / 60;
        const hour = hours%24 >=10 ? hours%24 : '0' + hours%24;
        const day = (hours-hour) / 24;
        if(day>=1){
          this.countDownTime = day + '天'+ hour + '时';
        }else{
          this.countDownTime = hour + ':'+ minute + ':'+ second;
        }
      }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/CountDown.vue